export function getReportConfig(reportConfig) {
  return {
    type: 'SET_REPORTS_CONFIG',
    payload: reportConfig,
  };
}

export default getReportConfig;
